import { Component, OnInit } from '@angular/core';
import { UserService } from '../../service/user.service';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from '@smartnowx/hcms-commons';
import { catchError, tap, throwError } from 'rxjs';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    standalone: false
})
export class RegisterComponent implements OnInit {

  showForm: boolean = true;
  errorMessage!: string;
  successMessage!: string;
  registerForm!: FormGroup;

  constructor(
    private translate: TranslateService,
    private userService: UserService,
    private fb: FormBuilder
  ) {

  }

  ngOnInit(): void {
    this.registerForm = this.fb.group({
      name: [null, Validators.required],
      username: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      password: [null, Validators.required],
      confirmPassword: [null, Validators.required]
    });
  }

  public register() {
    const { name, username, email, password, confirmPassword } = this.registerForm.value;

    this.errorMessage = '';
    this.successMessage = '';

    if (password !== confirmPassword) {
      this.errorMessage = this.translate.instant("register.passwords_do_not_match");
      return;
    }

    const user: User = {
      name,
      username,
      email,
      password
    } as User;

    this.userService.register(user)
      .pipe(
      catchError(error => {

        switch (error.status) {
          case 400:
            this.errorMessage = this.translate.instant("register.username_or_email_already_used");
            break;
          default:
            this.errorMessage = this.translate.instant("register.registration_failed");
            break;
        }
        
        return throwError(() => error);
      }),
      tap(response => {
          this.successMessage = this.translate.instant("register.registration_success");
          this.showForm = false;
          this.registerForm.reset(); 
      })
    ).subscribe();
  }

  get f() {
    return this.registerForm.controls;
  }
}
